// extracted by mini-css-extract-plugin
export default {"page":"userresetpasspage_page__emcxz","userProfileBlock":"userresetpasspage_userProfileBlock__xTNn6"};